import gql from 'graphql-tag';

export class FileMutations {
  static getUploadUrl = gql`
    mutation CreateDealroomFile($payload: CreateFileInput!) {
      createDealroomFile(payload: $payload) {
        file {
          id
        }
        presignedLink {
          url
          headers
        }
      }
    }
  `;

  static delete = gql`
    mutation DeleteDealroomFile($fileId: String!) {
      deleteDealroomFile(fileId: $fileId)
    }
  `;

  static update = gql`
    mutation UpdateDealroomFile($fileId: String!, $payload: UpdateFileInput!) {
      updateDealroomFile(fileId: $fileId, payload: $payload)
    }
  `;
}
